import { render, staticRenderFns } from "./nav-bar-notifications-dropdown-item.vue?vue&type=template&id=601d9038&"
import script from "./nav-bar-notifications-dropdown-item.vue?vue&type=script&lang=ts&"
export * from "./nav-bar-notifications-dropdown-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports